import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppContext } from '../AppContext';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

// Wrapper for protected routes
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { currentUserId } = useAppContext();
    const isGuest = currentUserId.includes('guest');

    // Add logic here if valid auth is required beyond just having a userId
    if (!currentUserId) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};
